import { render, staticRenderFns } from "./personalReport.vue?vue&type=template&id=4495812a&"
import script from "./personalReport.vue?vue&type=script&lang=js&"
export * from "./personalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports